import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: wrapper;

  display: flex;
  flex-flow: column wrap;

  padding: ${theme.spacings.mega};

  width: 100%;

  background: ${theme.colors.n100};

  border-radius: ${theme.borderRadius.giga};
`

const titleStyles = ({ theme }) => css`
  label: title;

  font-size: ${theme.typography.headings.kilo.fontSize};
  line-height: ${theme.typography.headings.kilo.lineHeight};
  font-weight: ${theme.font.weight.semibold};

  margin-bottom: ${theme.spacings.byte};
`

export const Wrapper = styled('div')(wrapperStyles)
export const Heading = styled('strong')(titleStyles)
